(function () {
  // Chargé une seule fois ; le clic est écouté sur toute la page,
  // donc les boutons continuent de marcher quand Dawn recharge le panier.
  if (window.CPU) return;
  window.CPU = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cpu__add');
    if (!btn) return;
    e.preventDefault();

    var card = btn.closest('.cpu__card');
    var variantId = card.querySelector('.cpu__variant').value;
    var errorEl = card.querySelector('.cpu__error');
    var genericError = (btn.closest('.cpu') && btn.closest('.cpu').dataset.error) || 'Error';
    var drawer = document.querySelector('cart-drawer');
    var useDrawer = drawer && typeof drawer.renderContents === 'function' && !/\/cart\/?$/.test(location.pathname);

    btn.disabled = true;
    errorEl.hidden = true;

    var body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (useDrawer) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = location.pathname;
    }

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          // Le message de Shopify (ex. stock insuffisant) est déjà dans la langue du visiteur
          errorEl.textContent = res.description || res.message || genericError;
          errorEl.hidden = false;
          btn.disabled = false;
          return;
        }

        if (useDrawer) {
          // Recharge le contenu du panier à droite (articles, total, barre de paliers)
          drawer.renderContents(res);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cartData: res });
          }
        } else {
          // Page Panier : on recharge la page pour tout mettre à jour
          location.reload();
        }
      })
      .catch(function () {
        errorEl.textContent = genericError;
        errorEl.hidden = false;
        btn.disabled = false;
      });
  });
})();
